import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function TodayRecommend() {
  const todayPicks = articles.filter(a => a.isTodayPick);

  return (
    <section id="today-picks" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-10">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
              今日推荐
            </h2>
            <p className="text-sm text-foreground-500 mt-2">编辑精选，每日更新</p>
          </div>
          <Link
            to="/category/all"
            className="hidden sm:inline-flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors cursor-pointer whitespace-nowrap"
          >
            查看全部 <i className="ri-arrow-right-line text-sm"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
          {todayPicks.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden hover:border-primary-300 transition-all duration-300 cursor-pointer no-underline"
            >
              <div className="relative overflow-hidden h-48">
                <img
                  src={article.coverImage}
                  alt={article.title}
                  title={`${article.title} - po文推荐`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 bg-primary-500/90 text-background-50 text-xs font-medium rounded-full">
                    今日推荐
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-sm font-semibold text-foreground-900 line-clamp-2 mb-2 group-hover:text-primary-600 transition-colors leading-snug">
                  {article.title}
                </h3>
                <p className="text-xs text-foreground-500 line-clamp-2 mb-3 leading-relaxed">
                  {article.excerpt}
                </p>
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-2">
                    <div className="w-6 h-6 rounded-full overflow-hidden bg-background-200">
                      <img src={article.author.avatar} alt={article.author.name} className="w-full h-full object-cover" />
                    </div>
                    <span className="text-xs text-foreground-500">{article.author.name}</span>
                  </div>
                  <span className="text-xs text-foreground-400">{article.readTime} 分钟阅读</span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-8 text-center sm:hidden">
          <Link
            to="/category/all"
            className="inline-flex items-center gap-1 text-sm text-primary-600 font-medium cursor-pointer"
          >
            查看全部 <i className="ri-arrow-right-line text-sm"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}